import * as angular from "angular";
import {$bringozFactory} from "../persistence-layer/bringoz-factory.factory";
import {BringozApi} from "../persistence-layer/models/bringoz-api.model";
import {DataStoreConfig} from "../persistence-layer/models/datastore-config.model";

angular
  .module('bringoz.admin.groups')
  .factory('$groups', GroupsObjectFactory);

/* @ngInject */
function GroupsObjectFactory($bringozFactory: $bringozFactory,
                             groupsAPI: BringozApi,
                             Groups_DS: DataStoreConfig,) {

  function $groups(id: string) {
    return $bringozFactory(id, groupsAPI, Groups_DS)
  }

  return $groups;
}
